/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IdentityProviderAttributeMapping } from './identityProviderAttributeMapping';
import { IdentityProviderClaimMatchRule } from './identityProviderClaimMatchRule';


export interface IdentityProviderRoleMappingRule { 
    /**
     * UID assigned to a mapping rule.
     */
    readonly instanceUid?: string;
    /**
     * Name of a mapping rule. Each mapping rule configured for a single identity provider must have a unique name.
     */
    name: string;
    /**
     * Name of an identity provider.
     */
    readonly providerName?: string;
    /**
     * Mapping rule description.
     */
    description?: string | null;
    /**
     * User role. 
     */
    role: IdentityProviderRoleMappingRuleRole;
    /**
     * Indicates whether a mapping rule is enabled.
     */
    enabled?: boolean;
    /**
     * Array of UIDs assigned to companies managed by a user. >Required for the `PortalOperator`, `PortalReadonlyOperator`, `ResellerOperator`, `ResellerUser`  and `ResellerAdministrator` user roles. 
     */
    managedCompaniesUids?: Array<string> | null;
    /**
     * Indicates whether a user must manage all available companies. Overrides values of the `managedCompaniesUids` property.
     */
    manageAllCompanies?: boolean;
    /**
     * Organization mapping claim type containing organization alias
     */
    organizationMappingSourceClaimType: string;
    /**
     * Location mapping claim containing user locations in the following format: `Location1;Location2`. >This property can be specified for the `CompanyLocationUser`, `CompanyLocationAdministrator` and `CompanySubtenant` user roles.  Otherwise a user is assigned to the first available company location. 
     */
    locationsMappingSourceClaimType?: string | null;
    /**
     * Array of additional mappings required for rule selection.
     */
    additionalMappings?: Array<IdentityProviderClaimMatchRule> | null;
    /**
     * Array of mapping claims attributed to user parameters.
     */
    attributeMappings?: Array<IdentityProviderAttributeMapping> | null;
    /**
     * Resource representation of the related identity provider entity.
     */
    _embedded?: object | null;
}
export enum IdentityProviderRoleMappingRuleRole {
    Unknown = 'Unknown',
    PortalAdministrator = 'PortalAdministrator',
    PortalOperator = 'PortalOperator',
    PortalReadonlyOperator = 'PortalReadonlyOperator',
    CompanyLocationUser = 'CompanyLocationUser',
    CompanyLocationAdministrator = 'CompanyLocationAdministrator',
    CompanyOwner = 'CompanyOwner',
    CompanyAdministrator = 'CompanyAdministrator',
    CompanyInvoiceAuditor = 'CompanyInvoiceAuditor',
    ResellerOwner = 'ResellerOwner',
    ResellerOperator = 'ResellerOperator',
    ResellerUser = 'ResellerUser',
    ResellerInvoiceAuditor = 'ResellerInvoiceAuditor',
    ResellerAdministrator = 'ResellerAdministrator'
};



